/* eslint-disable react-refresh/only-export-components */
import { createContext, useCallback, useMemo, useState, type ReactNode } from 'react';

export interface RefreshContextValue {
  refreshKey: number;
  bump: () => void;
}

export const RefreshContext = createContext<RefreshContextValue | undefined>(undefined);

interface RefreshProviderProps {
  children: ReactNode;
}

export function RefreshProvider({ children }: RefreshProviderProps) {
  const [refreshKey, setRefreshKey] = useState(0);
  const bump = useCallback(() => setRefreshKey((k) => k + 1), []);
  const value = useMemo<RefreshContextValue>(() => ({ refreshKey, bump }), [refreshKey, bump]);
  return <RefreshContext.Provider value={value}>{children}</RefreshContext.Provider>;
}
